import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetClassCapacityResponse {
  result: Array<ClassCapacityItem>;
  totalCount: number;
}

export interface ClassCapacityItem {
  id: string;
  name: string;
  registered: number;
  seatsAvailable: number;
  capacity: number;
  stuidioId: string;
  seatAvailabilityPercent: number;
  classes: Array<{
    className: string;
    classId: string;
    registered: number;
    maxSize: number;
    studioId: string;
  }>;
}

export interface GetClassCapacityParams {
  sessionId: string;
  groupBy: 'className' | 'groupName';
}

const getClassCapacityAPI = async (params: GetClassCapacityParams) => {
  const response = await baseAPI.get<Array<ClassCapacityItem>>(
    `/dashboard/class-capacity/${params.sessionId}`,
    {
      params: {
        groupBy: params.groupBy,
      },
    },
  );
  return response.data;
};

export const getClassCapacityOptions = (params: GetClassCapacityParams) =>
  queryOptions({
    queryKey: [KEYS.CLASS_CAPACITY, params],
    queryFn: () => getClassCapacityAPI(params),
    staleTime: 1000 * 60 * 5, // 5 minutes
    placeholderData: keepPreviousData,
  });

export const useGetClassCapacity = (params: GetClassCapacityParams) => {
  return useQuery(getClassCapacityOptions(params));
};
